import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { statusObj, PRIORITIES } from 'src/app/dummy/status';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { ICurriculumCourse } from 'src/app/interfaces/country';
import { pageKey, validSelected } from 'src/app/services/mapping.service';
import { debounceTime, tap, switchMap, take, map } from "rxjs/operators";
import { APPS } from 'src/app/dummy/app';
import { AuthService } from 'src/app/auth/auth.service';
import { List } from 'src/app/stores/administrator/list.store';
import { Master } from 'src/app/stores/administrator/master.store';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-add-curriculum-course',
  templateUrl: './add-curriculum-course.component.html',
  styleUrls: ['./add-curriculum-course.component.scss']
})
export class AddCurriculumCourseComponent implements OnInit {
  @ViewChild('focusInput', { static: false }) inputEl: ElementRef;
  LOADING: boolean = true;
  PRIORITIES = PRIORITIES;

  form: FormGroup;
  subject: AbstractControl;
  creditAttempted: AbstractControl;
  lectureHours: AbstractControl;
  labHours: AbstractControl;
  acYear: AbstractControl;
  acSemester: AbstractControl;
  priority: AbstractControl;
  order: AbstractControl;
  description: AbstractControl;

  constructor(public dialogRef: MatDialogRef<AddCurriculumCourseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
        public auth: AuthStore,
    public ds: DataService,
    private snackBar: MatSnackBar,
    public store: List,
    private master: Master,
  ) { }

  buildForm(): void {
    this.form = this.fb.group({
      subject: [null, Validators.compose([Validators.required, validSelected.bind(this)]), this.checkExist()],
      creditAttempted: [null, Validators.required],
      lectureHours: [null, Validators.required],
      labHours: [null, Validators.required],
      acYear: [null, Validators.required],
      acSemester: [null, Validators.required],
      priority: [PRIORITIES[0], Validators.required],
      order: [null, Validators.required],
      description: [null]
    });
    this.creditAttempted = this.form.controls['creditAttempted'];
    this.subject = this.form.controls['subject'];
    this.creditAttempted = this.form.controls['creditAttempted'];
    this.lectureHours = this.form.controls['lectureHours'];
    this.labHours = this.form.controls['labHours'];
    this.acYear = this.form.controls['acYear'];
    this.acSemester = this.form.controls['acSemester'];
    this.priority = this.form.controls['priority'];
    this.order = this.form.controls['order'];
    this.description = this.form.controls['description']
  }

  ngOnInit() {
    this.buildForm();
    this.store.fetchSubscribe(this.ds.subjectRef(ref => ref.orderBy("name")), subjects => {
      this.store.items = subjects;
      this.subject.valueChanges.pipe(
        debounceTime(APPS.DEBOUNCE_TIME),
        tap(() => (this.LOADING = true)),
        switchMap(value => this.store.search(value))
      ).subscribe(results => {
        this.store.items = results;
        this.store.process = false;
      });
    });
  }


  checkExist() {
    return (control: AbstractControl) => {
      const value = control.value;
      if (value !== null && value !== '' && value !== undefined && value.key) {
        return this.ds.curricularCourseRef(ref => ref.where("courseKey", '==', value.key).where("curriculumKey","==",this.data.SELECTED_CURRICULUM.key))
          .valueChanges()
          .pipe(
            debounceTime(APPS.DEBOUNCE_TIME),
            take(1),
            map(arr => {
              const val = arr.length > 0 ? { nameAvailable: true } : null;
              return val;
            })
          );
      }
    };
  }

  compareObjects(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.key === o2.key : o1 === o2;
  }


  displayItem(item: any): string {
    return item ? item.name : item;
  }

  create(f: any, isNew) {
    if (this.form.valid) {
      const { subject, creditAttempted, lectureHours, labHours, acYear, acSemester, priority, order, description } = f;
      const { SELECTED_CURRICULUM, TYPE } = this.data;
      const { facultyKey, majorKey, degreeKey, levelKey, key } = SELECTED_CURRICULUM;
      const item: ICurriculumCourse = {
        key: this.ds.createId(),
        page_key: pageKey(),
        created_date: new Date(),
        created_by: this.ds.userRef().doc(`${this.auth.user.uid}`).ref,
        isDeleted: false,
        status: statusObj.active,
        courseRef: this.ds.subjectRef().doc(subject.key).ref,
        courseKey: subject.key,
        creditAttempted: creditAttempted,
        lectureHours: lectureHours,
        labHours: labHours,
        acYear: acYear,
        acSemester: acSemester,
        priority: priority,
        order: order,
        description: description,
        facultyRef: this.ds.facultyRef().doc(facultyKey).ref,
        facultyKey: facultyKey,
        majorKey: majorKey,
        majorRef: this.ds.majorRef().doc(majorKey).ref,
        degreeKey: degreeKey,
        degreeRef: this.ds.degreeRef().doc(degreeKey).ref,
        levelKey: this.ds.levelRef().doc(levelKey).ref,
        levelRef: levelKey,
        curriculumKey: key,
        curriculumRef: this.ds.curricularRef().doc(key).ref,
        courseTypeKey: TYPE.key,
        courseTypeRef: this.ds.courseTypeRef().doc(TYPE.key).ref,
      }
      this.store.save(this.ds.curricularCourseRef(), item, (success, error) => {
        if (success) {
          if (!isNew) {
            this.dialogRef.close();
          }
          this.snackBar.open('Course has been added successfully.', 'Done', { duration: 3000 });
          this.form.reset();
          this.form.patchValue({
            priority
          })
          this.inputEl.nativeElement.focus();
        } else {
          this.snackBar.open(error, 'Error');
        }
      });
    }
  }

}
